import type { ExpiringDateKind } from '../api/types';

/** Short label per expiring-date kind — one map for the Compliance "Expiring dates" tab
 * and the Dashboard "Next 30 days" card (P11, 2026-10-10). */
export const EXPIRING_KIND_LABEL: Record<ExpiringDateKind, string> = {
  KYC: 'KYC',
  AML: 'AML',
  MIFID_SUITABILITY: 'MiFID',
  ID_EXPIRY: 'ID',
  // Beta v2 polish E (2026-05-26): legal-entity registry docs.
  PCC_EXPIRY: 'PCC',
  RCBE_EXPIRY: 'RCBE',
  // Beta #5 (2026-05-26, migration 0023): LEI annual renewal.
  LEI_EXPIRY: 'LEI',
  // P11 (2026-10-10): the spouse's ID document.
  SPOUSE_ID_EXPIRY: 'Spouse ID',
};
